/**
 * Formats menuItems
 * Sometimes when menuItems come back from the Back-end, the "page" or "category" property of a menuItem is an object,
 * but it should be a Page/Category IRI ('@id' property of a page/category) instead of an entire object.
 * @param {*} menuItems
 */
export const formatMenuItems = menuItems => {
  if (!menuItems || !menuItems.length) return;

  return menuItems.map(menuItem => {
    const formattedMenuItem = menuItem;
    if ("page" in menuItem) {
      formattedMenuItem.page = menuItem.page?.["@id"];
    }
    if ("category" in menuItem) {
      formattedMenuItem.category = menuItem.category?.["@id"];
    }

    return formattedMenuItem;
  });
};
